import PaymentDueSummary from "./PaymentDueSummary";
import { connect } from "react-redux";
import { getTotalExcludedTaxes, getQuoteTotal } from "app/pages/Booking/bookingSelectors";
import {
	calculatePartialPaymentAmount,
	getBookingPaymentMode,
	getPayNowAmount,
} from "app/pages/Booking/Payment/paymentSelector";
import { getHideDiscountHBX } from "app/reducers/brandSelector";

const mapStateToProps = state => {
	const payAtPropertyAmount = getTotalExcludedTaxes(state);
	const boardDiscount = Number(state?.booking?.board?.discount) || 0;
	const total = getQuoteTotal(state);
	const publicPrice = boardDiscount > 0 ? total + boardDiscount : 0;

	return {
		payNowAmount: getPayNowAmount(state),
		boardDiscount,
		total,
		publicPrice,
		paymentMode: getBookingPaymentMode(state),
		mensualite2Fois: calculatePartialPaymentAmount(state),
		payAtPropertyAmount,
		hideDiscountHBX: getHideDiscountHBX(state),
	};
};

export default connect(mapStateToProps)(PaymentDueSummary);
